const initAutocomplete2 = () => {
  const form = document.querySelector(".form_search_parking");
  const addressInput = document.getElementById("parking_address_2");
  const option = {
    types: ['address'],
    componentRestrictions: {country: 'fr'},
    fields: ['address_components', 'geometry', 'icon', 'name']
  }

  let autocomplete = new google.maps.places.Autocomplete(addressInput, option);

  autocomplete.addListener('place_changed', () => {
    // form.submit();
  })
};

export { initAutocomplete2 };
